import React from "react";
import { Container, Grid } from "@mui/material";
const TaxStrip = () => {
    return(
        <div className="SP---counter mb-sm-5 py-5" style={{backgroundColor: '#FFB347'}}>
            <Container maxWidth="lg">
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid
                        xs={12}
                        className="text-center"
                    >
                        <h4>Buy/Sell Tax: 6% (3% Liquidity And 3% Marketing/Buy-Backs/Listings)</h4>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default TaxStrip;
